/* Mom's Home: quick add, frequently bought together, recommendations, sticky add-to-cart */
(() => {
  if (window.mhUpsellLoaded) return;
  window.mhUpsellLoaded = true;

  const FMT = window.mhMoneyFormat || 'Rs.{{amount_no_decimals}}';
  const group = (cents, d, ts, ds) => {
    const [i, f] = (Number(cents || 0) / 100).toFixed(d).split('.');
    return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (f ? ds + f : '');
  };
  const money = (cents) =>
    FMT.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return group(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return group(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return group(cents, 0, '.', ',');
      return group(cents, 2, ',', '.');
    }).replace(/[.,]00(?!\d)/, '');
  window.mhMoney = money;
  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  let toastEl;
  const toast = (msg) => {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'mh-toast';
      toastEl.setAttribute('role', 'alert');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-on'), 3500);
  };

  const addUrl = () => ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';

  async function addItems(items, btn) {
    const cd = document.querySelector('cart-drawer');
    const body = { items };
    if (cd && typeof cd.getSectionsToRender === 'function') {
      body.sections = cd.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    if (btn) {
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
    }
    try {
      const res = await fetch(addUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mh-quick-add', productVariantId: items[0].id, cartData: data });
      }
      if (cd && data.sections && typeof cd.renderContents === 'function') {
        cd.classList.remove('is-empty');
        cd.renderContents(data);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
      if (btn) {
        btn.classList.add('is-added');
        setTimeout(() => btn.classList.remove('is-added'), 1800);
      }
      document.dispatchEvent(new CustomEvent('mh:added', { detail: { items, data } }));
      return data;
    } catch (e) {
      toast(e.message || 'Could not add to cart');
      throw e;
    } finally {
      if (btn) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
      }
    }
  }
  window.mhAddItems = addItems;

  /* Option picker for multi-variant quick add */
  const picker = {
    el: null,
    lastFocus: null,
    async open(handle, trigger) {
      this.lastFocus = trigger;
      trigger && trigger.classList.add('is-loading');
      let product;
      try {
        const r = await fetch(`/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
        if (!r.ok) throw new Error(r.status);
        product = await r.json();
      } catch (e) {
        window.location.href = `/products/${handle}`;
        return;
      } finally {
        trigger && trigger.classList.remove('is-loading');
      }
      this.product = product;
      const first = product.variants.find((v) => v.available) || product.variants[0];
      this.sel = [...first.options];
      this.render();
    },
    variant() {
      return this.product.variants.find((v) => v.options.every((o, i) => o === this.sel[i]));
    },
    possible(i, val) {
      return this.product.variants.some((v) => v.available && v.options[i] === val && v.options.every((o, j) => j === i || j > i || o === this.sel[j]));
    },
    render() {
      const p = this.product;
      if (!this.el) {
        this.el = document.createElement('div');
        this.el.className = 'mh-pick';
        this.el.setAttribute('role', 'dialog');
        this.el.setAttribute('aria-modal', 'true');
        this.el.addEventListener('click', (e) => {
          if (e.target.closest('[data-pick-close]')) return this.close();
          const ob = e.target.closest('[data-pick-opt]');
          if (ob) {
            this.sel[Number(ob.dataset.pickOpt)] = ob.dataset.value;
            return this.render();
          }
          const add = e.target.closest('[data-pick-add]');
          if (add) {
            const v = this.variant();
            if (!v || !v.available) return;
            addItems([{ id: v.id, quantity: 1 }], add)
              .then(() => this.close(true))
              .catch(() => {});
          }
        });
        this.el.addEventListener('keydown', (e) => e.key === 'Escape' && this.close());
        document.body.appendChild(this.el);
      }
      const v = this.variant();
      let img = (v && v.featured_image && v.featured_image.src) || p.featured_image || '';
      if (img) img = img + (img.includes('?') ? '&' : '?') + 'width=240';
      const opts = p.options
        .map((o, i) => {
          const name = typeof o === 'string' ? o : o.name;
          const vals = typeof o === 'string' ? [...new Set(p.variants.map((x) => x.options[i]))] : o.values;
          return `<fieldset class="mh-pick__opt"><legend>${esc(name)}: <b>${esc(this.sel[i])}</b></legend><div class="mh-pick__vals">${vals
            .map((val) => `<button type="button" class="mh-pick__val${val === this.sel[i] ? ' is-on' : ''}${this.possible(i, val) ? '' : ' is-na'}" data-pick-opt="${i}" data-value="${esc(val)}" aria-pressed="${val === this.sel[i]}">${esc(val)}</button>`)
            .join('')}</div></fieldset>`;
        })
        .join('');
      const ok = v && v.available;
      this.el.setAttribute('aria-label', `Choose options for ${p.title}`);
      this.el.innerHTML = `<div class="mh-pick__overlay" data-pick-close></div>
        <div class="mh-pick__panel">
          <button type="button" class="mh-pick__x" data-pick-close aria-label="Close">×</button>
          <div class="mh-pick__top">${img ? `<img src="${esc(img)}" alt="" width="84" height="84">` : ''}
            <div><p class="mh-pick__t">${esc(p.title)}</p>
            <p class="mh-pick__p"><span class="mh-price">${money(v ? v.price : p.price)}</span>${v && v.compare_at_price > v.price ? `<s class="mh-cmp">${money(v.compare_at_price)}</s>` : ''}</p>
            <a class="mh-pick__more" href="${esc(p.url || '/products/' + p.handle)}">View full details →</a></div></div>
          ${opts}
          <button type="button" class="mh-btn mh-pick__add" data-pick-add ${ok ? '' : 'disabled'}><span>${ok ? 'Add to cart' : 'Unavailable'}</span><span class="mh-spinner" aria-hidden="true"></span></button>
        </div>`;
      requestAnimationFrame(() => {
        this.el.classList.add('is-open');
        document.documentElement.classList.add('mh-pick-lock');
        const f = this.el.querySelector('.mh-pick__val.is-on') || this.el.querySelector('[data-pick-add]');
        f && f.focus({ preventScroll: true });
      });
    },
    close(added) {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      document.documentElement.classList.remove('mh-pick-lock');
      const el = this.el;
      this.el = null;
      setTimeout(() => el.remove(), 220);
      if (!added && this.lastFocus && document.contains(this.lastFocus)) this.lastFocus.focus({ preventScroll: true });
    },
  };
  window.mhPicker = picker;

  document.addEventListener('click', (e) => {
    const pk = e.target.closest('[data-mh-pick]');
    if (pk) {
      e.preventDefault();
      e.stopPropagation();
      picker.open(pk.dataset.mhPick, pk);
      return;
    }
    const b = e.target.closest('[data-mh-add]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    addItems([{ id: Number(b.dataset.mhAdd), quantity: 1 }], b).catch(() => {});
  });

  const onVariant = (cb) => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      return subscribe(PUB_SUB_EVENTS.variantChange, (ev) => {
        const v = ev && ev.data && ev.data.variant;
        if (v) cb(v, ev.data.sectionId);
      });
    }
    return null;
  };

  /* Frequently bought together */
  if (!customElements.get('mh-fbt')) {
    customElements.define(
      'mh-fbt',
      class extends HTMLElement {
        connectedCallback() {
          this.btn = this.querySelector('[data-fbt-add]');
          this.addEventListener('change', (e) => {
            if (e.target.matches('[data-fbt-item]')) this.update();
            if (e.target.matches('[data-fbt-select]')) {
              const row = e.target.closest('.mh-fbt__item');
              const cb = row.querySelector('[data-fbt-item]');
              const o = e.target.selectedOptions[0];
              cb.dataset.variant = o.value;
              cb.dataset.price = o.dataset.price;
              cb.dataset.compare = o.dataset.compare;
              row.querySelector('[data-fbt-price]').textContent = money(o.dataset.price);
              const c = row.querySelector('[data-fbt-cmp]');
              if (c) c.textContent = Number(o.dataset.compare) > Number(o.dataset.price) ? money(o.dataset.compare) : '';
              cb.checked = true;
              this.update();
            }
          });
          this.btn && this.btn.addEventListener('click', () => this.add());
          this.unsub = onVariant((v) => {
            const cb = this.querySelector('[data-fbt-main]');
            if (!cb) return;
            cb.dataset.variant = v.id;
            cb.dataset.price = v.price;
            cb.dataset.compare = v.compare_at_price || v.price;
            const p = this.querySelector('[data-fbt-main-price]');
            if (p) p.textContent = money(v.price);
            const t = this.querySelector('[data-fbt-main-variant]');
            if (t) t.textContent = v.title;
            cb.disabled = !v.available;
            if (!v.available) cb.checked = false;
            this.update();
          });
          this.update();
        }
        disconnectedCallback() {
          this.unsub && this.unsub();
        }
        checked() {
          return [...this.querySelectorAll('[data-fbt-item]')].filter((c) => c.checked && !c.disabled);
        }
        update() {
          const sel = this.checked();
          let total = 0;
          let cmp = 0;
          sel.forEach((c) => {
            total += Number(c.dataset.price);
            cmp += Number(c.dataset.compare || c.dataset.price);
          });
          this.querySelectorAll('[data-fbt-item]').forEach((c) => {
            const img = this.querySelector(`[data-fbt-img="${c.dataset.idx}"]`) || (c.dataset.idx === '0' ? this.querySelector('.mh-fbt__img--main') : null);
            if (img) img.classList.toggle('is-off', !c.checked);
          });
          const n = sel.length;
          this.querySelector('[data-fbt-total]').textContent = money(total);
          this.querySelector('[data-fbt-compare]').textContent = cmp > total ? money(cmp) : '';
          this.querySelector('[data-fbt-label]').textContent = n === 1 ? 'Total for 1 item' : `Total for ${n} items`;
          const bt = this.querySelector('[data-fbt-btn]');
          bt.textContent = n === 0 ? 'Select an item' : n === 1 ? 'Add to cart' : `Add ${n} items to cart`;
          this.btn.disabled = n === 0;
        }
        add() {
          const items = this.checked().map((c) => ({ id: Number(c.dataset.variant), quantity: 1 }));
          if (!items.length) return;
          addItems(items, this.btn).catch(() => {}).finally(() => this.update());
        }
      }
    );
  }

  /* Sticky add to cart (mobile) */
  if (!customElements.get('mh-sticky-atc')) {
    customElements.define(
      'mh-sticky-atc',
      class extends HTMLElement {
        connectedCallback() {
          if (this.parentElement !== document.body) {
            document.body.appendChild(this);
            return;
          }
          if (this.inited) return;
          this.inited = true;
          const sid = this.dataset.section;
          this.main = document.getElementById('ProductSubmitButton-' + sid);
          this.addBtn = this.querySelector('[data-sticky-add]');
          if (!this.main || !this.addBtn) return;
          this.addBtn.addEventListener('click', () => {
            this.main = document.getElementById('ProductSubmitButton-' + sid) || this.main;
            if (this.main.disabled || this.main.getAttribute('aria-disabled') === 'true') {
              this.main.scrollIntoView({ behavior: 'smooth', block: 'center' });
              return;
            }
            this.main.click();
          });
          this.check = () => {
            this.raf = 0;
            const m = document.getElementById('ProductSubmitButton-' + sid) || this.main;
            this.main = m;
            const r = m.getBoundingClientRect();
            this.toggle(r.bottom < 0);
          };
          this.onScroll = () => {
            if (!this.raf) this.raf = requestAnimationFrame(this.check);
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          this.check();
          // mirror the main button state (sold out / unavailable / enabled)
          this.sync = () => {
            const m = document.getElementById('ProductSubmitButton-' + sid) || this.main;
            const off = m.disabled || m.hasAttribute('disabled');
            const lab = this.querySelector('[data-sticky-label]');
            const sv = this.querySelector('[data-sticky-save]');
            this.addBtn.disabled = off;
            if (lab) lab.textContent = off ? ((m.querySelector('span') || m).textContent || '').trim() || 'Sold out' : 'Add to cart';
            if (sv) sv.hidden = off || !this.pct;
          };
          this.pct = (this.querySelector('[data-sticky-save]') || {}).hidden === false ? 1 : 0;
          this.mo = new MutationObserver(() => this.sync());
          this.mo.observe(this.main, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });
          this.unsub = onVariant((v, sectionId) => {
            if (sectionId && sectionId !== sid) return;
            const pr = this.querySelector('[data-sticky-price]');
            const cp = this.querySelector('[data-sticky-compare]');
            const vt = this.querySelector('[data-sticky-variant]');
            const sv = this.querySelector('[data-sticky-save]');
            const im = this.querySelector('[data-sticky-img]');
            if (pr) pr.textContent = money(v.price);
            if (cp) cp.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
            if (vt) vt.textContent = '· ' + v.title;
            const p = v.compare_at_price > v.price ? Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price) : 0;
            this.pct = p;
            if (sv) sv.textContent = '· SAVE ' + p + '%';
            if (im && v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) {
              const src = v.featured_media.preview_image.src;
              im.src = src + (src.includes('?') ? '&' : '?') + 'width=120';
              im.removeAttribute('srcset');
            }
            this.sync();
          });
          this.sync();
        }
        disconnectedCallback() {
          if (!this.inited) return;
          this.inited = false;
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
          this.unsub && this.unsub();
          this.mo && this.mo.disconnect();
          document.body.classList.remove('mh-sticky-on');
        }
        toggle(show) {
          if (this.shown === show) return;
          this.shown = show;
          this.classList.toggle('is-visible', show);
          this.setAttribute('aria-hidden', String(!show));
          this.addBtn.tabIndex = show ? 0 : -1;
          document.body.classList.toggle('mh-sticky-on', show);
        }
      }
    );
  }

  /* Recommendations ("You may also like"), same-collection cards stay as fallback */
  const cardHTML = (p) => {
    const v = (p.variants || []).find((x) => x.available) || (p.variants || [])[0];
    if (!v) return '';
    let img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && typeof img === 'object') img = img.src || '';
    const src = img ? img + (img.includes('?') ? '&' : '?') + 'width=400' : '';
    const off = v.compare_at_price > v.price ? Math.floor(((v.compare_at_price - v.price) * 100) / v.compare_at_price) : 0;
    return `<div class="mh-card mh-card--pdp"><div class="mh-card__top">
      <a href="${esc(p.url)}" class="mh-card__media" tabindex="-1" aria-hidden="true">${src ? `<img src="${esc(src)}" alt="${esc(p.title)}" loading="lazy" width="400" height="400">` : ''}${off >= 5 ? `<span class="mh-card__badge">-${off}%</span>` : ''}</a>
      ${v.available ? `<button type="button" class="mh-card__add" ${(p.variants || []).length > 1 ? `data-mh-pick="${esc(p.handle)}" aria-label="Choose options for ${esc(p.title)}"` : `data-mh-add="${v.id}" aria-label="Add ${esc(p.title)} to cart"`}><span class="mh-card__plus" aria-hidden="true">+</span><span class="mh-spinner" aria-hidden="true"></span></button>` : ''}</div>
      <div class="mh-card__info"><a href="${esc(p.url)}" class="mh-card__title">${esc(p.title)}</a>
      <div class="mh-card__price"><span class="mh-price">${money(v.price)}</span>${v.compare_at_price > v.price ? `<s class="mh-cmp">${money(v.compare_at_price)}</s>` : ''}</div></div></div>`;
  };
  const initRecs = (root = document) => {
    root.querySelectorAll('[data-mh-recs]:not([data-loaded])').forEach(async (sec) => {
      sec.setAttribute('data-loaded', '');
      const row = sec.querySelector('[data-mh-recs-row]');
      try {
        const res = await fetch(sec.dataset.url, { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error(res.status);
        const data = await res.json();
        const ex = String(sec.dataset.exclude);
        const list = (data.products || []).filter((p) => p.available && String(p.id) !== ex);
        if (list.length >= 4) {
          row.innerHTML = list.slice(0, 12).map(cardHTML).join('');
          const t = sec.querySelector('[data-mh-recs-title]');
          if (t && sec.dataset.altHeading) t.textContent = sec.dataset.altHeading;
          sec.dataset.source = 'recommendations';
        } else {
          sec.dataset.source = 'collection';
        }
      } catch (e) {
        sec.dataset.source = 'collection';
      }
      if (!row.children.length) sec.hidden = true;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initRecs());
  else initRecs();
  document.addEventListener('shopify:section:load', (e) => initRecs(e.target));
})();
